module.exports = __webpack_public_path__ + "static/img/image_wechat2.16a59b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page3/image_wechat2.png
// module id = t6/u
// module chunks = 1